import { Switch } from '@chakra-ui/react'

export default Switch
